import { gql } from '@apollo/client';
const DEACTIVATE_MODEL_SIZE = gql `
  mutation DeactivateModelSize($modelSpecificationSizeId: ID!) {
    deactivateModelSpecificationSize(modelSpecificationSizeId: $modelSpecificationSizeId) {
      modelSpecificationSize {
        id
        isActive
        sizeName {
          id
          name
        }
      }
    }
  }
`;
export default DEACTIVATE_MODEL_SIZE;
